<template>
  <div class="main-con el-main">
    <router-view />
  </div>
</template>

<script>
    export default {
        name: "CustomerApplyingVehicleMortgageCustomer"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/CustomerAdmin/CustomerApplyingVehicleMortgage.vue